import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { LocalizationLink } from 'tradera/components/site-header/localization-link';
import BackIcon from '@tradera/blueprint/theme/icons2/back.svg?jsx';
import { useTranslator } from 'tradera/lang/translate';
import useIsMobile from 'tradera/hooks/use-is-mobile';
import { Button } from 'tradera/components/atoms/button/button';

export const SwedenCountryCode = 'se';

const FormHeader = ({ showLanguageMenu, onBack }) => {
    const { t } = useTranslator();
    const isMobile = useIsMobile();
    const [showMenu, setShowMenu] = useState(false);

    const isNativeAppContext = useSelector(
        (state) => state.environment.isNativeAppContext
    );

    return (
        <div className="d-flex justify-content-between mt-2 mt-md-0">
            <div>
                {!!onBack && (
                    <Button theme="link" onClick={onBack} icon={<BackIcon />}>
                        {!isMobile && t('registration_sign_up_back')}
                    </Button>
                )}
            </div>
            <div>
                {showLanguageMenu && !isNativeAppContext && (
                    <span className={'position-relative'}>
                        <LocalizationLink
                            mouseOver={() => setShowMenu(true)}
                            mouseOut={() => setShowMenu(false)}
                            onClick={() => setShowMenu(!showMenu)}
                            onBlur={() => setShowMenu(false)}
                            showMenu={showMenu}
                            transparentHeader={true}
                            showIconAndTextInsteadOfFlag={true}
                            hideRegionSelection={true}
                        />
                    </span>
                )}
            </div>
        </div>
    );
};
export default FormHeader;
